import { Box, Stack } from "@mui/material";
import { useTranslate } from "@tolgee/react";
import React from "react";
import { FilterModal } from "../../commons/filters/FilterModal.js";
import { OutgoingQuotesFilters } from "../../main-routes/documents/Quotes.js";
import { QuotesAcceptanceSelect } from "./filters/QuotesAcceptance.js";
import { QuotesBindingSelect } from "./filters/QuotesBinding.js";
import { QuotesPublishingSelect } from "./filters/QuotesPublishing.js";

export function QuotesFilterModal<F extends OutgoingQuotesFilters>({
  handleClose,
  filters,
  setFilters,
  resetFilters,
  tab,
}: {
  handleClose: () => void;
  filters: F;
  setFilters: React.Dispatch<React.SetStateAction<F>>;
  resetFilters: () => void;
  tab: "outgoing" | "incoming";
}) {
  const { t } = useTranslate(["Quotes"]);

  const [filtersState, setFiltersState] = React.useState(filters);

  return (
    <FilterModal
      title={t("Quotes Filters", {
        ns: "Quotes",
      })}
      handleApply={() => {
        setFilters(filtersState);
      }}
      handleClose={handleClose}
      handleReset={() => resetFilters()}
      spacing={2}
    >
      <Stack direction="column" spacing={1}>
        {tab === "outgoing" ? (
          <Box>
            <QuotesPublishingSelect
              value={filtersState.filterIsPublished ?? []}
              setValue={newValue =>
                setFiltersState(state => ({
                  ...state,
                  filterIsPublished: newValue,
                }))
              }
            />
          </Box>
        ) : undefined}
        <Box>
          <QuotesBindingSelect
            value={filtersState.filterIsBinding ?? []}
            setValue={newValue =>
              setFiltersState(state => ({
                ...state,
                filterIsBinding: newValue,
              }))
            }
          />
        </Box>
        <Box>
          <QuotesAcceptanceSelect
            value={filtersState.filterAgreement ?? []}
            setValue={newValue =>
              setFiltersState(state => ({
                ...state,
                filterAgreement: newValue,
              }))
            }
          />
        </Box>
      </Stack>
    </FilterModal>
  );
}
